import * as IoC from 'inversify';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import * as Serialization from '../serialization'

export const questionAttemptCommonTrackingModule = new IoC.ContainerModule((bind) => {
  bind(StateSerializationPluginSymbol).to(Serialization.QuestionAttemptsStateProtobufSerializer)
})
